import * as React from 'react'

export const useCombinedRefs = <T extends Element>(...refs: React.Ref<T>[]) => {
  const targetRef = React.useRef<T>(null)

  React.useEffect(() => {
    refs.forEach(ref => {
      if (!ref) return

      if (typeof ref === 'function') {
        ref(targetRef.current)
      } else {
        (ref.current as T | null) = targetRef.current
      }
    })
  }, [refs])

  return targetRef
}
